import * as React from "react";
import LoginPopup from "./loginPopup";
import "../../../assets/scss/components/login/generic/rmRatingSuccPopup.scss";

export interface IRmRatingSuccPopupProps {
	onClose: () => void;
}

const RmRatingSuccPopup: React.FC<IRmRatingSuccPopupProps> = props => {
	return (
		<LoginPopup onClose={props.onClose} className="rm_rating_ppup" hideVersion>
			<div className="cont">
				<div className="cir_icon">
					<i className="edel-icon-tick"></i>
				</div>

				<h2 className="title mg-t30">We have noted your preference</h2>
				<p className="msg mg-t10 mg-b40">
					If you wish to rate in the future,
					<br />
					you can do so anytime.
				</p>
			</div>
		</LoginPopup>
	);
};

export default RmRatingSuccPopup;
